import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const TerreoPagina = () => {
  return (
    <div className="terreo-container">
      <GroupLightComponent
        groupIds={["grupo01", "grupo02", "grupo03", "grupo04", "grupo05", "grupo06","grupo07", "grupo08", 
          "grupo09","grupo10","grupo11","grupo12","grupo13", "grupo14", "grupo15", "grupo16", "grupo17", 
          "grupo30"]}
        pageId="1"
      />
    </div>
  );
};

export default TerreoPagina;